import "./StockModal.scss";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import StockModal from "./StockModal";
import getIcon from "../../../../utility/getIcon";
import { normalizeStockLinks } from "../../../../utility/stockManagement";

const ProductLine = ({ product }) => (
  <div className="associated-product-line">
    <img
      src={getIcon(product.category, product.customIcon)}
      className="associated-product-line-image"
    />
    <div className="associated-product-line-info">
      <p className="associated-product-line-info-label">{product.title}</p>
    </div>
  </div>
);

export default function AssociatedProductsModal({ open, onClose, product, orgProducts = [] }) {
  const { t } = useTranslation("stockManagement");

  const associatedProducts = useMemo(
    () =>
      orgProducts.filter((currentProduct) =>
        normalizeStockLinks(currentProduct).some((link) => link.stockItemId === product?.id),
      ),
    [orgProducts, product?.id],
  );

  return (
    <StockModal
      open={open}
      onClose={onClose}
      title={t("associated_products_modal_title", {
        name: product?.name ? ` - ${product.name}` : "",
      })}
    >
      <div className="stock-action-modal-products">
        <p className="stock-action-modal-products-subtitle">
          {t("associated_products_modal_subtitle")}
        </p>

        {associatedProducts?.length > 0 ? (
          <div className="stock-action-modal-products-container">
            {associatedProducts.map((product) => (
              <ProductLine key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <p className="stock-action-modal-products-empty-container">
            {t("associated_products_modal_empty")}
          </p>
        )}
      </div>
    </StockModal>
  );
}
